// ─────────────────────────────────────────────────────────────────────────────
// 🔑 THE DOORLYPRO DASHBOARD'S STATUS BADGE (P6 (a), Jesse 2026-11-01).
//
// "DoorlyPro Partner" used to be the fallback whenever readiness was null — still loading, the GET /onboarding
// readiness read failed, or the request failed — and read like a partner group. It is gone: the badge is the
// partner's real state.
//   · readiness answered → Archived / Setup in progress / ✓ Active Partner, from it (as before);
//   · readiness null and still loading → no badge (null);
//   · readiness null after loading → the STORED onboarding_status: archived → Archived; active → ✓ Active Partner;
//     anything else (or unknown) → Setup in progress.
// The header eyebrow "DoorlyPro Partner" is a label, not a status, and is not this.
// ─────────────────────────────────────────────────────────────────────────────

export const ACTIVE_LABEL = '✓ Active Partner';
export const SETUP_LABEL = 'Setup in progress';
export const ARCHIVED_LABEL = 'Archived';

/**
 * @param {{ loading: boolean, readiness: object|null, storedStatus: string|null }} s
 * @returns {string|null} the badge text, or null for no badge
 */
export function statusBadgeLabel({ loading, readiness, storedStatus }) {
  if (readiness) {
    if (readiness.status === 'archived' || storedStatus === 'archived') return ARCHIVED_LABEL;
    return readiness.ready ? ACTIVE_LABEL : SETUP_LABEL;
  }
  if (loading) return null;
  if (storedStatus === 'archived') return ARCHIVED_LABEL;
  if (storedStatus === 'active') return ACTIVE_LABEL;
  return SETUP_LABEL;
}
